// ORCA360 - Mobile Workflow Header
// Slim header with back navigation and session context

import { ArrowLeft, X } from 'lucide-react';

interface MobileHeaderProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  onClose?: () => void;
}

export default function MobileHeader({
  title,
  subtitle,
  onBack,
  onClose,
}: MobileHeaderProps) {
  return (
    <div
      className="z-40 bg-navy text-white pt-safe"
      style={{ boxShadow: '0 2px 8px rgba(11, 44, 69, 0.2)' }}
    >
      <div className="flex items-center gap-1.5 px-2 py-0.5 max-w-lg mx-auto">
        {/* Back button */}
        {onBack && (
          <button
            onClick={onBack}
            className="flex items-center justify-center w-6 h-6 -ml-0.5 rounded-full hover:bg-white/10 transition-colors"
            aria-label="Go back"
          >
            <ArrowLeft size={14} />
          </button>
        )}

        {/* Title area */}
        <div className="flex-1 min-w-0">
          <h1 className="text-xs font-bold text-white truncate leading-none">{title}</h1>
          {subtitle && (
            <p className="text-[9px] text-white/60 truncate leading-none mt-0.5">{subtitle}</p>
          )}
        </div>

        {/* Close button */}
        {onClose && (
          <button
            onClick={onClose}
            className="flex items-center justify-center w-6 h-6 -mr-0.5 rounded-full hover:bg-white/10 transition-colors"
            aria-label="Close workflow"
          >
            <X size={14} />
          </button>
        )}
      </div>
    </div>
  );
}
